import $ from "jquery";

$(document).on("turbolinks:load", function() {
  $(".populate-organisation-owner").on("click", function () {
    var displayName = $("#company_form_display_name").val();
    if (!displayName) {
      alert("Display name is blank.");
      return false;
    }
    var ownerOrganisation = $("#company_form_name");
    ownerOrganisation.val(displayName);
  });


  $("#company_form_ownership_type_id").change(function () {
    var selectedOption = $("#company_form_ownership_type_id").val();

    if (selectedOption + "" === $("#company_form_ownership_type_id").data().subsidiaryId + "") {
      $(".jump-to-ownership-structure-button").removeClass("hidden");
    } else {
      $(".jump-to-ownership-structure-button").addClass("hidden");
    }
  });
  $("#company_form_ownership_type_id").change();

  $(".jump-to-ownership-structure-button").click(function () {
    var id = $(".jump-to-ownership-structure-button").data().expandHtmlId;
    $(".section-toggle-button").filter("[href*='#" + id + "']").click();
  });
});
